import { render, staticRenderFns } from "./ReceivableRegister.vue?vue&type=template&id=76451739&"
import script from "./ReceivableRegister.vue?vue&type=script&lang=js&"
export * from "./ReceivableRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports